import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { HubContextFacade } from './hub-context.facade';

@Injectable({
  providedIn: 'root',
})
export class HubContextGuard  {
  constructor(private hubContextFacade: HubContextFacade) {}

  canActivate(): Observable<boolean> {
    return loadStoreState(this.hubContextFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.hubContextFacade);
  }
}
